import { FC, useMemo } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icons, SelectList, Tooltip } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import { useLazySearchEntities } from '../../../../../api/queries/useLazySearchEntities';
import { Entity } from '../../../../../api/types/Entity';

interface Props {
    user: Entity | undefined;
    setUser: (user: Entity) => void;
}

const UserSelectList: FC<Props> = ({ user, setUser }) => {
    const icon = user ? Icons.Edit : Icons.Add;
    const text = user ? 'Edit' : 'Add';

    const { data, searchEntities, resetData } = useLazySearchEntities();

    const userOptions = useMemo(() => {
        return data.map((o) => ({ title: o.name, value: o.guid, subtitle: `(${o.domainName})` }));
    }, [data]);

    const onSelect = (val: string | string[] | undefined) => {
        if (Array.isArray(val)) {
            return;
        }
        const user = data.find((o) => o.guid === val);
        if (user) {
            setUser(user);
        }
        resetData();
    };
    return (
        <div className="flex items-center gap-2">
            {user && (
                <div className="flex font-normal h-6 px-2 gap-2 bg-sf-neutral-100 rounded-sm items-center self-center text-12 text-sf-gray-800">
                    <div className="max-w-[104px]">
                        <Tooltip onlyOnOverflow title={user.name}>
                            <span>{user.name}</span>
                        </Tooltip>
                    </div>
                    <span>|</span>
                    <div className="max-w-[124px]">
                        <Tooltip onlyOnOverflow title={user.name}>
                            <span className="text-sf-gray-500">{user.domainName}</span>
                        </Tooltip>
                    </div>
                </div>
            )}
            <SelectList
                TriggerComponent={Button}
                triggerProps={{
                    text,
                    iconLeft: icon,
                    buttonStyle: ButtonStyles.Tertiary,
                    buttonSize: ButtonSizes.Small
                }}
                items={userOptions}
                searchable
                searchHandler={(text) => {
                    searchEntities({ entitiesTypes: [AD_ENTITY_TYPES.USER], searchQuery: text });
                }}
                onChange={onSelect}
                searchPlaceholder="Search by name"
                width={232}
            />
        </div>
    );
};
export default UserSelectList;
